var _defs, _clipPath, _g, _path, _g2, _path2, _g3, _g4, _g5, _radialGradient, _path3, _g6, _radialGradient2, _path4, _radialGradient3, _path5, _g7, _g8, _g9, _radialGradient4, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleChromeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: 800,
    width: 1200,
    viewBox: "-26.4 -44 228.8 264",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    y2: 44.354,
    x2: 81.837,
    y1: 75.021,
    x1: 29.337,
    gradientUnits: "userSpaceOnUse",
    id: "f",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    y2: 130.33,
    x2: 52.538,
    y1: 164.5,
    x1: 110.87,
    gradientUnits: "userSpaceOnUse",
    id: "g",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    y2: 114.13,
    x2: 136.55,
    y1: 49.804,
    x1: 121.86,
    gradientUnits: "userSpaceOnUse",
    id: "j",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    y2: 114.13,
    x2: 136.55,
    y1: 49.804,
    x1: 121.86,
    gradientUnits: "userSpaceOnUse",
    id: "k",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    y2: 44.354,
    x2: 81.837,
    y1: 75.021,
    x1: 29.337,
    gradientUnits: "userSpaceOnUse",
    id: "n",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    y2: 130.33,
    x2: 52.538,
    y1: 164.5,
    x1: 110.87,
    gradientUnits: "userSpaceOnUse",
    id: "r",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 88,
    cx: 96,
    cy: 96,
    id: "d"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("use", {
    height: "100%",
    xlinkHref: "#d",
    overflow: "visible",
    width: "100%"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)",
    transform: "translate(-8 -8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#db4437",
    d: "M21.97 8v108h39.39L96 56h88V8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 29.337,
    x2: 81.837,
    y1: 75.021,
    gradientUnits: "userSpaceOnUse",
    y2: 44.354,
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0.6,
    stopColor: "#A52714"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopOpacity: 0,
    stopColor: "#A52714"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M21.97 8v108h39.39L96 56h88V8z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3e2723",
    transform: "translate(-8 -8)",
    d: "M62.31 115.65L22.48 47.34l-.58 1 39.54 67.8z",
    fillOpacity: 0.15,
    clipPath: "url(#e)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)",
    transform: "translate(-8 -8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0f9d58",
    d: "M8 184h83.77l38.88-38.88V116H61.36L8 24.48z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 110.87,
    x2: 52.538,
    y1: 164.5,
    gradientUnits: "userSpaceOnUse",
    y2: 130.33,
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0.4,
    stopColor: "#055524"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopOpacity: 0,
    stopColor: "#055524"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M8 184h83.77l38.88-38.88V116H61.36L8 24.48z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    transform: "translate(-8 -8)",
    d: "M129.84 117.33l-.83-.48L90.62 184h1.15l38.1-66.64z",
    fillOpacity: 0.15,
    clipPath: "url(#e)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)",
    transform: "translate(-8 -8)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M8 184h83.77l38.88-38.88V116H61.36L8 24.48z",
    id: "h"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("use", {
    height: "100%",
    xlinkHref: "#h",
    overflow: "visible",
    width: "100%"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffcd40",
    d: "M96 56l34.65 60-38.88 68H184V56z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 121.86,
    x2: 136.55,
    y1: 49.804,
    gradientUnits: "userSpaceOnUse",
    y2: 114.13,
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0.3,
    stopColor: "#EA6100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopOpacity: 0,
    stopColor: "#EA6100"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M96 56l34.65 60-38.88 68H184V56z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)",
    transform: "translate(-8 -8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffcd40",
    d: "M96 56l34.65 60-38.88 68H184V56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M96 56l34.65 60-38.88 68H184V56z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)",
    transform: "translate(-8 -8)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M96 56l34.65 60-38.88 68H184V56z",
    id: "l"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("use", {
    height: "100%",
    xlinkHref: "#l",
    overflow: "visible",
    width: "100%"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#db4437",
    d: "M21.97 8v108h39.39L96 56h88V8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M21.97 8v108h39.39L96 56h88V8z"
  })))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    r: 84.078,
    gradientTransform: "translate(-576)",
    cx: 668.18,
    cy: 55.948,
    gradientUnits: "userSpaceOnUse",
    id: "o"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0.2,
    stopColor: "#3E2723"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    stopColor: "#3E2723"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    transform: "translate(-8 -8)",
    d: "M96 56v20.95L174.4 56z",
    clipPath: "url(#e)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)",
    transform: "translate(-8 -8)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.97 8v40.34L61.36 116 96 56h88V8z",
    id: "p"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "q"
  }, /*#__PURE__*/React.createElement("use", {
    height: "100%",
    xlinkHref: "#p",
    overflow: "visible",
    width: "100%"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#q)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0f9d58",
    d: "M8 184h83.77l38.88-38.88V116H61.36L8 24.48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M8 184h83.77l38.88-38.88V116H61.36L8 24.48z"
  })))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    r: 78.044,
    gradientTransform: "translate(-576)",
    cx: 597.88,
    cy: 48.52,
    gradientUnits: "userSpaceOnUse",
    id: "s"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0.2,
    stopColor: "#3E2723"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    stopColor: "#3E2723"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    transform: "translate(-8 -8)",
    d: "M21.97 48.45l57.25 57.24L61.36 116z",
    clipPath: "url(#e)"
  })), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    r: 87.87,
    gradientTransform: "translate(-576)",
    cx: 671.84,
    cy: 96.138,
    gradientUnits: "userSpaceOnUse",
    id: "t"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0.2,
    stopColor: "#263238"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    stopColor: "#263238"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#t)",
    transform: "translate(-8 -8)",
    d: "M91.83 183.89l20.96-78.2L130.65 116z",
    clipPath: "url(#e)"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)",
    transform: "translate(-8 -8)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#f1f1f1",
    r: 40,
    cx: 96,
    cy: 96
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4285f4",
    r: 32,
    cx: 96,
    cy: 96
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)",
    transform: "translate(-8 -8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3e2723",
    d: "M96 55c-22.09 0-40 17.91-40 40v1c0-22.09 17.91-40 40-40h88v-1z",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M130.6 116c-6.92 11.94-19.81 20-34.6 20-14.8 0-27.69-8.06-34.61-20h-.04L8 24.48v1L61.36 117h.04c6.92 11.94 19.81 20 34.61 20 14.79 0 27.68-8.05 34.6-20h.05v-1z",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3e2723",
    d: "M97 56c-.17 0-.33.02-.5.03C118.36 56.3 136 74.08 136 96c0 21.92-17.64 39.7-39.5 39.97.17 0 .33.03.5.03 22.09 0 40-17.91 40-40s-17.91-40-40-40z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M131 117.33c3.4-5.88 5.37-12.68 5.37-19.96 0-4.22-.66-8.28-1.87-12.09.95 3.42 1.5 7.01 1.5 10.73 0 7.28-1.97 14.08-5.37 19.96l.02.04-38.88 68h1.16l38.09-66.64z",
    fillOpacity: 0.2
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)",
    transform: "translate(-8 -8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M96 9c48.43 0 87.72 39.13 87.99 87.5 0-.17.01-.33.01-.5 0-48.6-39.4-88-88-88S8 47.4 8 96c0 .17.01.33.01.5C8.28 48.13 47.57 9 96 9z",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3e2723",
    d: "M96 183c48.43 0 87.72-39.13 87.99-87.5 0 .17.01.33.01.5 0 48.6-39.4 88-88 88S8 144.6 8 96c0-.17.01-.33.01-.5C8.28 143.87 47.57 183 96 183z",
    fillOpacity: 0.15
  }))), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    r: 176.75,
    gradientTransform: "translate(-8 -8)",
    cx: 34.286,
    cy: 32.014,
    gradientUnits: "userSpaceOnUse",
    id: "u"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0.1,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0,
    stopColor: "#fff"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#u)",
    r: 88,
    cx: 88,
    cy: 88
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleChromeLogo);
export default __webpack_public_path__ + "static/media/googleChromeLogo.56af9a419b0336f891cd4496de6c54ce.svg";
export { ForwardRef as ReactComponent };